import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder';
import { scaffolderReactTranslationRef } from '@backstage/plugin-scaffolder-react';

/** Template list strings of the Criar page in pt-BR. */
export const scaffolderMessages = TranslationBlueprint.make({
  name: 'byx-scaffolder',
  params: {
    resource: createTranslationMessages({
      ref: scaffolderTranslationRef,
      messages: {
        'templateListPage.templateGroups.defaultTitle': 'Templates',
        'templateListPage.templateGroups.otherTitle': 'Outros',
        'templateListPage.contentHeader.registerExistingButtonTitle':
          'Registrar existente',
        'templateListPage.additionalLinksForEntity.viewTechDocsTitle':
          'Ver TechDocs',
      },
    }),
  },
});

export const scaffolderReactMessages = TranslationBlueprint.make({
  name: 'byx-scaffolder-react',
  params: {
    resource: createTranslationMessages({
      ref: scaffolderReactTranslationRef,
      messages: {
        'templateCategoryPicker.title': 'Categorias',
      },
    }),
  },
});
